if(typeof _.minBy === 'undefined') { var e = new Error("Cannot find module '_.minBy'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = _.minBy;